import { ScopeVersion } from '@app/core/model/scope-version'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { plainToInstance } from 'class-transformer'
import { ScopeSection } from '../../model/scope-section'
import { Dictionary, keyBy } from 'lodash'
import { SectionWithChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/section-with-changes.interface'
import { getSectionChanges } from './entity-changes'

export function mapChangeRequestSections(
  scope: ScopeVersion,
  previewScope: ScopeVersion,
  deliverablesBySection: Dictionary<Deliverable[]>
): SectionWithChanges[] {
  const scopeSections = scope?.sections || []
  const sectionIds = new Set(scopeSections.map((c) => c.id))
  const sections = [...scopeSections, ...(previewScope?.sections || []).filter((p) => !sectionIds.has(p.id))]
  const previewSectionsMap = keyBy(previewScope?.sections, 'id')

  return plainToInstance(
    ScopeSection,
    sections
      .sort((a, b) => a.order - b.order)
      .map((section) => ({
        ...section,
        deliverables: (deliverablesBySection[section.id] || []).sort((a, b) => a.order - b.order),
        changes: getSectionChanges(section, previewSectionsMap[section.id], scope.identity.rateCard.currencyCode),
      }))
  )
}
